import styled from "@emotion/styled/macro";
import Box from "@mui/material/Box";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledTrackingModalContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  width: "520px",
  display: "flex",
  flexDirection: "column",
  background: "#fff",
  outline: "none",
  borderRadius: "4px",
}));

export const StyledTrackingSettingHeader = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: `1px solid ${theme.customColors.grey[300]}`,
  padding: "24px 24px",
}));

export const StyledTrackingSettingBody = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  padding: "0px 24px",
  maxHeight: "750px",
  overflowY: "scroll",
}));

export const StyledTrackingSettingBodyContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  fontSize: "14px",
  color: theme.customColors.grey[600],
  lineHeight: "20px",
}));

export const StyledExcludeUserContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  border: `1px solid ${theme.customColors.grey[300]}`,
  padding: "11px 8px 11px 12px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
}));

export const StyledExcludeUserIcon = styled("img", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  borderRadius: 20,
  marginRight: 8,
  height: 20,
  width: 20,
}));

export const StyledTrackingSettingFooter = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  borderBottom: `1px solid ${theme.customColors.grey[300]}`,
  padding: "24px 24px",
  columnGap: "12px",
  boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.10)",
}));
